(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aura-offers')) {
    customElements.define('aura-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const active = this.dataset.active === 'true';
        const preview = !active && window.Shopify?.theme?.role !== 'main' && (window.Shopify?.designMode || new URLSearchParams(location.search).get('aura_offer_preview') === '1');
        const available = active || preview;
        this.offer = this.querySelector('.aura-offer-dialog');
        this.payment = this.querySelector('.aura-payment-dialog');
        this.key = `maison-aura-offer-${preview ? 'preview' : 'active'}-20261030`;
        this.querySelectorAll('[data-aura-promo]').forEach(item => { item.hidden = !available; });
        const previewNote = this.querySelector('[data-offer-preview]');
        if (previewNote) previewNote.hidden = !preview;
        this.querySelector('[data-open-offer]')?.addEventListener('click', () => { if (available) this.show(this.offer); }, options);
        this.querySelector('[data-open-payment]')?.addEventListener('click', () => this.show(this.payment), options);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => dialog.close(), options));
          dialog.addEventListener('click', event => {
            const rect = dialog.getBoundingClientRect();
            if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
          }, options);
          dialog.addEventListener('close', () => { if (dialog === this.offer) this.remember(); }, options);
        });
        this.querySelector('[data-offer-cta]')?.addEventListener('click', () => this.remember(), options);
        let seen = false;
        try { seen = sessionStorage.getItem(this.key) === '1'; } catch {}
        if (available && this.dataset.home === 'true' && !seen && !window.Shopify?.designMode) {
          this.timer = setTimeout(() => {
            if (!document.querySelector('dialog[open], details[open].menu-drawer-container') && document.visibilityState === 'visible') this.show(this.offer);
          }, Number(this.dataset.delay) || 7000);
        }
      }
      show(dialog) { if (dialog && !dialog.open) { dialog.showModal(); if (dialog === this.offer) this.remember(); } }
      remember() { try { sessionStorage.setItem(this.key, '1'); } catch {} }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
